import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../../shared/services/payment.service';
import { SessionService } from '../../../shared/services/session.service';
import { CurrencyPipe } from '@angular/common';

import swal from 'sweetalert2';
import { PendingTransactions } from '../../../shared/models/pending-transactions.model';
import { ApiConfig } from '../../../shared/services/config/api.config';
import { AuthService } from '../../../shared/services/auth.service';
import { MenuUtility } from '../../../shared/utilities/menu.utility';

declare var jQuery: any;

@Component({
  selector: 'app-pay-on-line',
  templateUrl: './pay-on-line.component.html',
  styleUrls: ['./pay-on-line.component.css']
})
export class PayOnLineComponent implements OnInit {

  valorCuotaMP: string;

  transaccionesPendientes: boolean;

  showSpinnerTransaccionesPendientes: boolean;

  nombreUsuario: string;

  identificacion: string;

  email: string;

  numContrato: string;

  factura: string;

  obj: any;

  formPagos: { valor: '' };

  regTransaccionesPendientes: PendingTransactions[];

  amount: number;
  formattedAmount: string = '';



  @ViewChild('pichurria') pichurria;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _sessionService: SessionService,
    private _paymentService: PaymentService,
    private currencyPipe: CurrencyPipe,
    private _api: ApiConfig,
    private _authService: AuthService
  ) { }

  ngOnInit() {

    this.toggleSidebar();
    MenuUtility.selectOption('menuPagoEnLinea');

    this.nombreUsuario = '';
    this.identificacion = '';
    this.numContrato = '';
    this.email = '';
    this.factura ='';

    let _strSession = sessionStorage.getItem('sessionPagos');

    this.obj = JSON.parse(_strSession);

    if(this.obj != null)
    this.nombreUsuario = this.obj.nombreUsuario;

    this.showSpinnerTransaccionesPendientes = true;
    this._paymentService.getPendingTransactions(this._sessionService.getSelectContract()).subscribe(
      res => {

        this.showSpinnerTransaccionesPendientes = false;

        let _transactions = res;

        if (_transactions.length > 0) {//transacciones pendientes
          this.transaccionesPendientes = true;
          this.regTransaccionesPendientes = _transactions;

        } else {
          this.transaccionesPendientes = false;

          this.valorCuotaMP = this.obj.valorPago;
          this.numContrato = this.obj.contrato;
          this.identificacion = this.obj.identificacion;
          this.email = this.obj.email;
          this.factura = this.obj.factura;
          //this.amount =  this.obj.valorPago;
        }

      },
      err => {
        this.showSpinnerTransaccionesPendientes = false;
        console.log(err);
      }
    )

  }

  transformAmount(e: any) {

    if (!isNaN(this.amount)) {
      this.formattedAmount = this.currencyPipe.transform(this.amount, 'USD');
      e.target.value = this.formattedAmount;
    }
  }

  enterInput(event) {
    if (this.amount) {
      this.formattedAmount = '' + this.amount;
    }

  }

  toggleSidebar() {
    jQuery('.app-sidebar').removeClass('active');
    jQuery('.app-container').removeClass('__sidebar');
  }

  irHomeEstadoCuenta() {
    this.router.navigate(['/office/account_status/status']);
  }

  continuarPago() {
    //console.log(this.amount);
    //console.log(this.formattedAmount);

    if (this.amount === undefined) {
      swal({
        title: 'Pagos en Línea',
        html: '<p style="font-size:14px">Favor ingrese el valor a pagar</p>',
        type: 'error',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;

    }

    if (this.amount.toString().trim() === '' || isNaN(this.amount)) {
      swal({
        title: 'Pagos en Línea',
        html: '<p style="font-size:14px">El valor a pagar ingresado es inválido</p>',
        type: 'error',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }

    if (this.amount > this.obj.valorPago) {
      swal({
        width: 400,
        title: 'Pagos en Línea',
        html: `<p style="font-size:14px">El valor digitado debe ser menor o igual a <b>${this.currencyPipe.transform(this.obj.valorPago, 'USD')}</b></p>`,
        type: 'warning',
        confirmButtonClass: 'btn btn-primary',
        buttonsStyling: false,
        focusConfirm: false
      });
      return;
    }


    let _html = '';
    _html += `
    <p style="font-size: 15px; text-align: left; font-weight: bold">Confirme que los datos estén correctos</p>
    <table id="tableResumenCitaMedica" class="table table-bordered">
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Nombre</td>
        <td>${this.nombreUsuario}</td>
      </tr>
      <tr>
        <td style="background-color: #1d7bbb; color: #ffff">Identificación</td>
        <td>${this.identificacion}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Numero de Contrato</td>
        <td>${this._sessionService.getSelectContract()}</td>
      </tr>
      <tr>
      <td style="background-color: #1d7bbb; color: #ffff">Numero de Factura</td>
        <td>${this.factura}</td>
      </tr>
    </table>

    <div style="color: #1d7bbb; text-align: center; padding: 3px">
      <h4>Valor a Pagar:</h4>
    </div>

    <div style="text-align: center; color: #f8b03c">
      <h3>${this.formattedAmount}</h3>
    </div>

    <div class="row">
    <div style="text-align: justify">

      <blockquote style="font-size: 13px; color: #1d7bbb">
        <span style="font-weight: bold">Estimado usuario:</span>
        <p>
          Si tienes dudas o inquietudes sobre este proceso por favor comunícate gratis a nuestro Contact Center al teléfono 7420101
          en Bogotá o a nivel Nacional al 01-8000-184000 o al correo electrónico
          <em>ServicioAlCliente@medplus.com.co </em>
        </p>
      </blockquote>
      </div>
    </div>

    `;

    swal({
      width: 600,
      padding: 30,
      showCloseButton: true,
      type: 'question',
      html: _html,
      animation: true,
      allowOutsideClick: false,
      confirmButtonClass: 'btn btn-success btn-confirm-modal',
      confirmButtonText: 'Continuar',
      showCancelButton: true,
      cancelButtonClass: 'btn btn-info',
      cancelButtonText: 'Volver',
      buttonsStyling: false,
      focusConfirm: false,
      showLoaderOnConfirm: true,
      onOpen: () => {
        jQuery("#tableResumenCitaMedica").addClass("tableConfirmaCitaMedica");
      },
    }).then((result) => {
      if (result.value) {

        if (this._authService.isAuthenticateManagement()) {
          swal({
            width: 400,
            title: 'Pagos en Línea',
            html: `<p style="font-size:14px">Esta solicitud no puede ser procesada en el entorno de gestión</b></p>`,
            type: 'warning',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false,
            focusConfirm: false
          });
        } else {
          if (this._authService.isAuthenticate()) {
            let _url = `/payment?ref=${this._sessionService.getSelectContract().trim()}&iden=${this.identificacion.trim()}&mail=${this.email.trim()}&val=${this.amount}&fac=${this.factura}`;
            window.location.href = this._api.urlPortalPagos + _url;
          } else {
            swal({
              width: 400,
              title: 'Pagos en Línea',
              html: `<p style="font-size:14px">Lo sentimos ha ocurrido un error con la solicitud</b></p>`,
              type: 'warning',
              confirmButtonClass: 'btn btn-primary',
              buttonsStyling: false,
              focusConfirm: false
            });
          }
        }

      }
    })




  }

}



// WEBPACK FOOTER //
// /app/src/app/office/account-status/pay-on-line/pay-on-line.component.ts